export default __webpack_public_path__ + "dd3bcd9a137e8c2441d59d21c21461d6.png";